import * as React from 'react';

export default function Qrcode() {
  return (
    <img id="qrcode" src="../image/qrcode.png"></img>
  )
}
